export const requiredValidator =
  (label = 'Field') =>
  (value: string | undefined): string | undefined => {
    if (!value) {
      return `${label} is required`;
    }
    return undefined;
  };
